<template>
  <b-container class="profile-history" v-if="customerInfo">
    <div>
        <h2 class="profile-title">Your profile details</h2>
    </div>

    <div class="profile-content">

    <div id="avatar">
      <b-avatar variant="light" :src="avatarUrl" size="11.4375rem"></b-avatar>
      <h2 v-if="false" style="weight: bold;">{{ customerInfo.user.firstName }}</h2>
    </div>
    <div class="profile-info">
    <h4>Dropsmart App</h4>
    <p>
      <span v-if="customerInfo.user.paid == false">Free </span>
      <span v-else-if="customerInfo.user.paid == true">Premium </span>
      <span v-else>Free </span>
      user
    </p>
    </div>
    </div>
  </b-container>
</template>

<script>
import { FRONTEND_URL } from "../../../config";

export default {
  name: "Profile",
  props: ["customerInfo"],
  components: {  },
  computed: {
    avatarUrl() {
      if (!this.customerInfo || !this.customerInfo.user.avatarUrl) {
        return null;
      }
      return FRONTEND_URL.AvatarURL + this.customerInfo.user.avatarImage;
    },
  },
  data() {
    return {
    }
  },
};
</script>

<style scoped lang="scss">

.profile-history {
  margin: initial;
  padding: 50px 0;
  height: 100%;
  .profile-title {
    font-size: 30px;
    font-weight: 700;
    margin-bottom: 35px;
  }
}

.profile-content {
  display: flex;
  justify-content: left;

  .profile-info {
    margin-left: 5rem;
  }
}
</style>
